module.exports = __webpack_public_path__ + "img/dataset_view_details.d1c9186b.png";